import { computed, reactive } from 'vue';
import { helpers } from '@vuelidate/validators';

class InfoFinancieraValidacion {
  public ObtenerReglasValidacion() {
    const MAX_TAMANIO_ARCHIVO = 20 * 1024 * 1024;

    const EXTENSIONES_VALIDAS = [
      'image/jpeg',
      'image/png',
      'application/pdf',
      'application/default',
    ];

    const MENSAJES_ERROR = {
      tamaño: 'El tamaño no puede superar 20MB',
      extension: 'La extensión válida de tus archivos es (PNG, JPEG, PDF)',
      obligatorio: 'Debes adjuntar al menos un archivo',
      nombreDuplicado: 'Asegúrate de que tus archivos no contengan el mismo nombre',
      valorRequerido: 'El campo es obligatorio',
    };

    const objetoFinanciera = reactive({
      Documentos: {
        ExtensionesArchivos: [{
          Id: 0,
          Extension: 'application/default',
        }],
      } as Archivo,
      IngresosOperacionales: 0,
      IngresosNoOperacionales: 0,
      JustificacionIngresos: '',
      Archivos: new FormData(),
      TamañoArchivo: 0,
      NombresArchivos: [{
        Id: 0,
        Nombre: '',
      }] as Nombre[],
      BuenasPracticas: '',
    });

    const validarTamanio = helpers.withParams(
      { type: 'TamañoArchivo', max: MAX_TAMANIO_ARCHIVO },
      (valor: number) => valor <= MAX_TAMANIO_ARCHIVO
    );

    const validarObligatorioArchivo = helpers.withParams(
      { type: 'objeto' },
      (lista: Extension[]) => lista.length > 1
    );

    const validarExtension = helpers.withParams(
      { type: 'extensionesArchivo' },
      (archivos: Extension[]) =>
        !archivos.some(archivo => !EXTENSIONES_VALIDAS.includes(archivo.Extension))
    );

    const validarNombresUnicos = helpers.withParams(
      { type: 'NombresArchivos' },
      (archivos: Nombre[]) => {
        const nombres = archivos.map(a => a.Nombre);
        return new Set(nombres).size === nombres.length;
      }
    );

    const validarMoneda = helpers.withParams(
      { type: 'moneda' },
      (valor: number) => valor > 0
    );

    const validarJustificacionIngresos = helpers.withParams(
      { type: 'justificacionCondicional' },
      () => {
        const operacionales = Number(objetoFinanciera.IngresosOperacionales) || 0;
        const noOperacionales = Number(objetoFinanciera.IngresosNoOperacionales) || 0;
        const justificacion = objetoFinanciera.JustificacionIngresos?.trim() || '';

        const condicion = noOperacionales >= operacionales;
        return !condicion || justificacion.length > 0;
      }
    );

    const reglasValidacion = computed(() => ({
      IngresosOperacionales: {
        Obligatorio: helpers.withMessage(
          MENSAJES_ERROR.valorRequerido,
          validarMoneda
        ),
      },
      IngresosNoOperacionales: {
        Obligatorio: helpers.withMessage(
          MENSAJES_ERROR.valorRequerido,
          validarMoneda
        ),
      },
      JustificacionIngresos: {
        Obligatorio: helpers.withMessage(
          MENSAJES_ERROR.valorRequerido,
          validarJustificacionIngresos
        ),
      },
      TamañoArchivo: {
        tamaño: helpers.withMessage(
          MENSAJES_ERROR.tamaño,
          validarTamanio
        ),
      },
      NombresArchivos: {
        nombre: helpers.withMessage(
          MENSAJES_ERROR.nombreDuplicado,
          validarNombresUnicos
        ),
      },
      Documentos: {
        ExtensionesArchivos: {
          extension: helpers.withMessage(
            MENSAJES_ERROR.extension,
            validarExtension
          ),
          obligatorio: helpers.withMessage(
            MENSAJES_ERROR.obligatorio,
            validarObligatorioArchivo
          ),
        },
      },
    }));

    return [objetoFinanciera, reglasValidacion] as const;
  }
}

export default InfoFinancieraValidacion;